export type DocumentsCreateNewFolderState = {
  loading: boolean,
  isOpen: boolean,
}

export const state: DocumentsCreateNewFolderState = {
  loading: false,
  isOpen: false,
}
